import { useEffect, useState } from 'react';
import { DISPLAY_MODE_QUERIES, getInstallContext } from '../utils/environment';

export function useInstallAppStatus() {
  const [context, setContext] = useState(() => getInstallContext());

  useEffect(() => {
    if (typeof window === 'undefined') return undefined;

    let mediaCleanup = null;

    const updateContext = () => {
      setContext(getInstallContext());
    };

    const mediaQueries =
      typeof window.matchMedia === 'function'
        ? DISPLAY_MODE_QUERIES.map((query) => {
            try {
              return window.matchMedia(query);
            } catch {
              return null;
            }
          }).filter(Boolean)
        : [];

    if (mediaQueries.length > 0) {
      const handleMediaChange = () => updateContext();
      mediaQueries.forEach((mq) => {
        if (typeof mq.addEventListener === 'function') {
          mq.addEventListener('change', handleMediaChange);
        } else if (typeof mq.addListener === 'function') {
          mq.addListener(handleMediaChange);
        }
      });
      mediaCleanup = () => {
        mediaQueries.forEach((mq) => {
          if (typeof mq.removeEventListener === 'function') {
            mq.removeEventListener('change', handleMediaChange);
          } else if (typeof mq.removeListener === 'function') {
            mq.removeListener(handleMediaChange);
          }
        });
      };
    }

    const handleVisibilityChange = () => {
      if (typeof document !== 'undefined' && document.visibilityState === 'visible') {
        updateContext();
      }
    };

    updateContext();
    window.addEventListener('appinstalled', updateContext);
    window.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      mediaCleanup?.();
      window.removeEventListener('appinstalled', updateContext);
      window.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);

  return context;
}
